import SEO from "@/components/SEO";
import { EMAIL, PHONE_DISPLAY, PIVA } from "@/data/content";

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="font-display text-xl md:text-2xl tracking-tight text-anthracite mb-4">{title}</h2>
    <div className="text-sm md:text-base text-anthracite/70 leading-relaxed space-y-3">{children}</div>
  </section>
);

const Privacy = () => (
  <>
    <SEO
      title="Privacy Policy — SOPAJ Impresa Edile"
      description="Informativa sul trattamento dei dati personali di Sopaj Demir — Impresa Edile, Nibionno (LC)."
      path="/privacy-policy"
    />
    <div data-testid="privacy-page" className="max-w-3xl mx-auto px-5 md:px-8 pt-36 md:pt-48 pb-24 md:pb-36">
      <h1 className="font-display text-4xl sm:text-5xl tracking-tight text-anthracite mb-4">Privacy Policy</h1>
      <p className="text-sm text-concrete mb-12">Informativa ai sensi dell'art. 13 del Regolamento (UE) 2016/679 (GDPR)</p>

      <Section title="Titolare del trattamento">
        <p>
          Sopaj Demir — Impresa Edile, Via Monsignor Boffa, 5 — 23895 Nibionno (LC),
          P. IVA {PIVA}. Telefono: {PHONE_DISPLAY}. E-mail: {EMAIL}.
        </p>
      </Section>

      <Section title="Dati raccolti e finalità">
        <p>
          Attraverso il modulo di contatto raccogliamo nome, telefono, e-mail, comune
          dell'immobile, tipologia di intervento e messaggio. I dati vengono utilizzati
          esclusivamente per ricontattarti, organizzare il sopralluogo e predisporre
          eventuali preventivi.
        </p>
      </Section>

      <Section title="Base giuridica e conservazione">
        <p>
          Il trattamento si basa sul consenso dell'interessato e sull'esecuzione di
          misure precontrattuali. I dati sono conservati per il tempo necessario a
          gestire la richiesta e comunque non oltre 24 mesi, salvo instaurazione di un
          rapporto contrattuale.
        </p>
      </Section>

      <Section title="Comunicazione a terzi">
        <p>
          I dati non vengono ceduti né diffusi a terzi. Possono essere trattati da
          fornitori tecnici (hosting e servizio di invio e-mail) nel rispetto del GDPR.
        </p>
      </Section>

      <Section title="Diritti dell'interessato">
        <p>
          Puoi richiedere in qualsiasi momento accesso, rettifica, cancellazione,
          limitazione o opposizione al trattamento dei tuoi dati scrivendo a {EMAIL}.
          Hai inoltre diritto di reclamo al Garante per la protezione dei dati personali.
        </p>
      </Section>
    </div>
  </>
);

export default Privacy;
